import { Avatar } from 'antd';
import { UserOrganizationAccess } from '../../../api/organization';

export interface OrganizationProps {
  organizationAccess: UserOrganizationAccess;
  onClick?: (organizationAccess: UserOrganizationAccess) => void;
}

export const OrganizationItem = ({ organizationAccess, onClick }: OrganizationProps) => {
  const handleClick = (e: any) => {
    onClick && onClick(organizationAccess);
  };

  return (
    <div
      className="flex flex-shrink-0 items-center gap-2 pl-2 cursor-pointer rounded hover:bg-neutral-200"
      onClick={handleClick}
    >
      <Avatar src={organizationAccess.organizationPicturePath} shape="square" size={24}>
        {organizationAccess?.name.substring(0, 1)}
      </Avatar>
      <div className="flex-grow min-w-0 h-9 flex-col justify-center items-start inline-flex">
        <div
          className="text-brand-grey-dark text-sm font-medium leading-tight w-full truncate"
          title={organizationAccess.name}
        >
          {organizationAccess.name}
        </div>
        <div className="text-neutral-900 text-xs font-normal leading-none">{`${organizationAccess.OrganizationAccess.length} ${organizationAccess.OrganizationAccess.length === 1 ? ' member' : ' members'}`}</div>
      </div>
    </div>
  );
};
